import t from '@jetshop/intl';
import { theme } from '../../../Theme';
import { styled } from 'linaria/react';
import React from 'react';
import { ReactComponent as FilterIcon } from '../../../../svg/filter-tool.svg';

const ButtonWrapper = styled('div')`
  display: flex;
  justify-content: flex-end;
`;

const Button = styled('button')`
  background: transparent;
  border-radius: 0;
  border: none;
  cursor: pointer;
  text-align: left;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  outline: none;
  padding: 10px 10px 10px 0;
  margin-bottom: 20px;
  margin-right: 20px;
  p {
    transition: all 0.2s ease;
    padding-right: 10px;
  }
`;

const IconWrapper = styled('div')`
  display: flex;
  align-items: center;
  position: relative;
  pointer-events: auto;
  line-height: 20px;
  font-size: 16px;
  font-weight: 400;
  color: ${theme.colors.black};
  svg {
    width: 18px;
    height: 13px;
    margin-right: 5px;
  }
  &.active {
    color: ${theme.colors.red};
    svg {
      color: ${theme.colors.red};
    }
  }

  ${theme.below.lg} {
    font-size: 10px;
    line-height: 14px;
    svg {
      width: 14px;
      height: 10px;
    }
  }
`;

const FilterButton = ({ showTarget, active }) => {
  return (
    <ButtonWrapper>
      <Button onClick={showTarget}>
        <IconWrapper className={active && 'active'}>
          <FilterIcon />
          {t('Filter')}
        </IconWrapper>
      </Button>
    </ButtonWrapper>
  );
};

export default FilterButton;
